import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=4e1117ad&scoped=true&"
import script from "./Assignment.vue?vue&type=script&lang=js&"
export * from "./Assignment.vue?vue&type=script&lang=js&"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=4e1117ad&prod&scoped=true&lang=css&"
import style1 from "./Assignment.vue?vue&type=style&index=1&id=4e1117ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1117ad",
  null
  
)

export default component.exports